var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-title-text",class:{ inline: _vm.inline }},[_c('div',{staticClass:"icon"},[(_vm.icon)?_c('span',{class:_vm.icon}):_vm._e(),_vm._t("icon")],2),_c('title-text',_vm._b({},'title-text',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }